<template>
  <div>
    <vue-headful
    :title="Dashboard | Cancel Reasons"
    :description="Dashboard | Cancel Reasons"
/>

<div>

  <h1 style="text-align: center;" class="mt-7">Cancel Subscription</h1>
<br>
<div class="nav-tabs sc-bvTASY jPMoWD" style="overflow: scroll;display: flex;">
<a href="/dashboard/account" exact-active-class="activetabs" class="nav-item nav-link" style="border-radius: .5rem .5rem 0 0!important;border-left: .0625rem solid transparent; border-right: .0625rem solid transparent; border-top: .0625rem solid transparent;border-bottom: 0;">Account Settings</a>
<router-link to="/dashboard/cancel-reasons" exact-active-class="activetabs" class="nav-item nav-link" style="border-radius: .5rem .5rem 0 0!important;border-left: .0625rem solid transparent; border-right: .0625rem solid transparent; border-top: .0625rem solid transparent;border-bottom: 0;">Cancel Subscription</router-link>
</div>

</div>

    <div class="sc-kEYyzF grKTOC">
       <div class="sc-kAdXeD jwoEpG" style="padding: 0px 0px 30px 0px!important">
          <div class="sc-bvTASY jPMoWD">
             <div class="sc-cFlXAS WflZx">
                <div style="position: relative;">

                <div>
                  <div class="card border-light shadow-soft" style="margin-bottom:20px;margin: 0 auto;padding: 10px;border-left: .0625rem solid rgba(243,247,250,.05); border-right: .0625rem solid rgba(243,247,250,.05); border-bottom: .0625rem solid rgba(243,247,250,.05); border-top: 0; border-radius: 0 0 .5rem .5rem;">
                     <div class="card-body p-4 p-lg-3">
                             <div>
                               <div v-if="propsdata[0].paid === 'yes' && propsdata[0].cancel_at_period_end !== 'yes'" class="col-12">
                               <div v-if="!are_you_sure && !canceled" class="form-group">
                                 <h5 class="mb-2">What is your reason for cancelling Logo.app?</h5>
                                 <p>Select the one that applies</p>
                                 <p v-if="select_reason" style="color:#ff0000">You need to select a reason first in order to cancel your subscription.</p>
                                  <div class="form-check">
                                      <input class="form-check-input" type="radio" id="exampleRadios1" value="1" v-model="reason">
                                      <label class="form-check-label" for="exampleRadios1">
                                        No longer using Logo.app
                                      </label>
                                  </div>
                                  <div class="form-check">
                                      <input class="form-check-input" type="radio" id="exampleRadios2" value="2" v-model="reason">
                                      <label class="form-check-label" for="exampleRadios2">
                                        Found a better software
                                      </label>
                                  </div>
                                  <div class="form-check">
                                      <input class="form-check-input" type="radio" id="exampleRadios3" value="3" v-model="reason">
                                      <label class="form-check-label" for="exampleRadios3">
                                        Prices are too high
                                      </label>
                                  </div>
                                  <div class="form-check">
                                      <input class="form-check-input" type="radio" id="exampleRadios4" value="4" v-model="reason">
                                      <label class="form-check-label" for="exampleRadios4">
                                        Other
                                      </label>
                                      <p v-if="fill_reason && reason === '4'" style="color:#ff0000" class="mt-2">Please share with us more details about why you are cancelling your Logo.app subscription.</p>
                                      <input v-if="reason === '4'" v-model="other_reason" type="text" class="form-control mt-2" placeholder="Please share more details so we can improve"></input>
                                  </div>
                                 <button v-if="!saving" @click="save_reason" class="btn btn-danger mt-4 animate-up-2 mobilesinfloat" style="float:right!important;">Continue & Cancel Subscription</button>
                                 <button v-if="saving" class="btn btn-danger mt-4 animate-up-2 mobilesinfloat" style="float:right!important;"><i class="fas fa-spinner"></i> Loading</button>
                               </div>
                               <div v-if="are_you_sure && !canceled">
                                   <h5 class="mb-2">You're about to cancel your subscription</h5>
                                   <small>Your subscription to Logo.app will be canceled immediately, losing all ownership from your logos.</small>
                                   <div class="alert alert-warning alert-dismissible fade show mb-0 mt-3" role="alert">
                                      <span class="alert-inner--icon"><i class="fas fa-exclamation-circle"></i></span>
                                      <span class="alert-inner--text"><strong>Warning:</strong> You will lose all access and ownership of your logos, including all the premium features.</span>
                                    </div>
                                   <button v-if="!cancelling" @click="cancel" class="btn btn-danger mt-4 animate-up-2 mobilesinfloat" style="float:right!important;">Cancel my subscription</button>
                                   <button v-if="cancelling" class="btn btn-danger mt-4 animate-up-2 mobilesinfloat" style="float:right!important;"><i class="fas fa-spinner"></i> Cancelling</button>
                                   <p v-if="cancellation_error" class="mt-3" style="color:red;">Cancellation failed. Please contact us at support@logo.app or in our <a href="https://logo.app/contact" target="_blank" style="color: red; text-decoration: underline;">contact page</a>.</p>
                               </div>
                               <div v-if="canceled">
                                 <h5 class="mb-2">Your subscription is canceled</h5>
                                 <p>Your subscription has been canceled and your credit card will not longer be charged. You've no longer access and ownership of your logos.</p>
                                 <h5 class="mb-2">Restart subscription</h5>
                                 <p>Made a mistake? If you want to restart your subscription, just <a :href="'/payment/sub/'+propsdata[0].unique_id" style="color:#00d56d;text-decoration:underline;">click here</a></p>
                               </div>
                               <a href="/dashboard/billing" class="btn btn-success mt-4 animate-up-2"><i class="fas fa-chevron-left"></i> Return to billing</a>
                               </div>
                               <div v-else-if="propsdata[0].canceled === 'yes' || propsdata[0].cancel_at_period_end === 'yes'">
                                <div class="col-12">
                                 <h4 class="mb-0">You are currently not subscribed.</h4>
                                </div>
                               </div>
                             </div>
                     </div>
                 </div>

</div>


             </div>
          </div>
       </div>
    </div>
 </div>

</div>

</template>

<style>
a {
  color: #515151;
}
@media (max-width:991px) {
  .card{
    width:100%!important;
  }
}
.card-body {
    flex: 1 1 auto;
    padding: 1.5rem;
}
/* .row {
    display: flex;
    flex-wrap: wrap;
    margin-right: -15px;
    margin-left: -15px;
} */
.col-12 {
    flex: 0 0 100%;
    max-width: 100%;
}
.form-group {
    position: relative;
}
.form-group {
    margin-bottom: 1rem;
}
.text-dark, .text-dark:hover {
    color: #0d1431 !important;
}
.form-label {
    font-weight: 400;
    font-size: 1rem;
    display: block;
}
.text-danger, .text-danger:hover {
    color: #FA5252 !important;
}
.input-group {
    border-radius: 0.5rem;
    transition: all 0.2s ease;
}
.mb-4, .my-4 {
    margin-bottom: 1.5rem !important;
}
.input-group {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    width: 100%;
}
.input-group-prepend {
    margin-right: -2px;
}
.input-group-text {
    font-size: 0.875rem;
    transition: all 0.3s ease-in-out;
}
.fa, .fas {
    font-weight: 900;
}
.fa, .far, .fas {
    font-family: "Font Awesome 5 Free";
}
.input-group .form-control:not(:first-child) {
    border-left: 0;
    padding-left: 0;
}
.input-group > .form-control, .input-group > .form-control-plaintext, .input-group > .custom-select, .input-group > .custom-file {
    position: relative;
    flex: 1 1 auto;
    width: 1%;
    margin-bottom: 0;
}
.input-group .form-control:not(:first-child) {
    border-left: 0;
    padding-left: 0;
}
.text-center {
    text-align: center !important;
}
.animate-up-2, .animate-right-2, .animate-down-2, .animate-left-2, .scale-up-2, .scale-down-2 {
    transition: all 0.2s ease;
}
button:not(:disabled), [type="button"]:not(:disabled), [type="reset"]:not(:disabled), [type="submit"]:not(:disabled) {
    cursor: pointer;
}
.mr-2, .mx-2 {
    margin-right: 0.5rem !important;
}
.nav-tabs .nav-link:hover {
    border: none;
}
.editandowebsite {
    background-color: #f9fafb;
    border-color: #1e90ff5e;
    outline: 0;
    box-shadow: inset 0 1px 2px rgb(46 54 80 / 8%), 0 0 0 0.2rem rgb(38 43 64 / 20%);
}
.activetabs{
  background: #ffffff!important;
  border-color: #dde1ed!important;
  color: #ed1d62!important;
}
@media (max-width:786px) {
  .mobilesinfloat{
    float: none!important;
  }
}
</style>

  <script>
  import ClickOutside from 'vue-click-outside';

  export default {
    props:['propsdata'],
    data() {
      return {
        reason: '',
        other_reason: '',
        saving: false,
        select_reason: false,
        fill_reason: false,
        are_you_sure: false,
        cancelling: false,
        canceled: false,
        cancellation_error: false
      };
    },
    methods: {
      save_reason(){
        if(this.reason == ''){
          this.select_reason = true;
        }
        else{
        if(this.reason == '4' && this.other_reason == ''){
          this.fill_reason = true;
        }
        else{
        this.select_reason = false;
        this.fill_reason = false;
        this.saving = true;
        axios.post('/dashboard/save-reason.php', {
          token: lukastoken,
          reason: this.reason,
          other_reason: this.other_reason
          })
          .then(response => {
            this.are_you_sure = true;
        })
          .catch(function (error) {
            console.log(error);
          });
      }
      }
    },
    cancel(){
      this.cancellation_error = false;
      this.cancelling = true;
      axios.post('https://logo.app/user-cancel-subscription', {
        token: lukastoken
        })
        .then(response => {
          this.cancelling = false;
          this.canceled = true;
      })
        .catch((error) => {
          console.log(error);
          this.cancelling = false;
          this.cancellation_error = true;
        });
    }
    },
    mounted() {
      this.$emit('updateprops');
    },
    // do not forget this section
directives: {
  ClickOutside
}
  };
  </script>



// WEBPACK FOOTER //
// src/cancel-reasons.vue